export const prefetchImages = [
'/images/1/1/log_in.png',
'/images/1/1/log_out.png',
'/images/1/1/site_time_out.png',
'/images/1/1/sysCompatibility.png',
'/images/1/5/1.png',
'/images/1/5/2.png',
'/images/1/5/3.png',
'/images/1/5/4.png',
'/images/1/5/5.png',
'/images/1/5/6.png',
'/images/1/5/7.png',
'/images/2/1/1.png',
'/images/2/1/10.png',
'/images/2/1/11.png',
'/images/2/1/12.png',
'/images/2/1/13.png',
'/images/2/1/2.png',
'/images/2/1/3.png',
'/images/2/1/4.png',
'/images/2/1/7.png',
'/images/2/1/8.png',
'/images/2/1/9.png',
'/images/2/2/assign_user_role.jpg',
'/images/2/2/create_new_user.jpg',
'/images/2/2/create_user_menu_link.jpg',
'/images/2/2/set_home_page.jpg',
'/images/2/2/user_details_form.jpg',
'/images/2/2/workflow_created.jpg',
'/images/2/3/1.jpg',
'/images/2/3/2.jpg',
'/images/2/3/3.jpg',
'/images/2/3/4.jpg',
'/images/2/3/5.jpg',
'/images/2/3/6.jpg',
'/images/2/3/7.jpg',
'/images/2/4/1.jpg',
'/images/2/4/2.jpg',
'/images/2/4/3.jpg',
'/images/2/4/4.jpg',
'/images/2/4/5.jpg',
'/images/2/4/6.jpg',
'/images/2/4/7.jpg',
'/images/3/1/1.png',
'/images/3/1/2.png',
'/images/3/1/3.png',
'/images/3/1/4.png',
'/images/3/2/1.png',
'/images/3/2/10.png',
'/images/3/2/2.png',
'/images/3/2/3.png',
'/images/3/2/4.png',
'/images/3/2/5.png',
'/images/3/2/6.png',
'/images/3/2/7.png',
'/images/3/2/8.png',
'/images/3/2/9.png',
'/images/3/3/1/1.png',
'/images/3/3/1/2.png',
'/images/3/3/1/3.png',
'/images/3/3/1/4.png',
'/images/3/3/2/1.png',
'/images/3/3/2/2.png',
'/images/3/3/2/3.png',
'/images/3/3/2/4.png',
'/images/3/3/3/1.png',
'/images/3/3/3/2.png',
'/images/3/3/3/3.png',
'/images/3/3/3/4.png',
'/images/3/3/4/1.png',
'/images/3/3/4/2.png',
'/images/3/3/4/3.png',
'/images/3/3/4/4.png',
'/images/3/3/5/1.png',
'/images/3/3/5/2.png',
'/images/3/3/5/3.png',
'/images/3/3/5/4.png',
'/images/3/3/5/5.png',
'/images/3/3/5/6.png',
'/images/3/3/5/7.png',
'/images/3/3/5/8.png',
'/images/3/3/5/9.png',
'/images/3/3/6/1.png',
'/images/3/3/6/2.png',
'/images/3/3/6/3.png',
'/images/3/3/6/4.png',
'/images/3/3/7/1.png',
'/images/3/3/7/2.png',
'/images/3/3/8/1.png',
'/images/3/3/8/2.png',
'/images/3/3/8/3.png',
'/images/3/3/8/4.png',
'/images/3/3/8/5.png',
'/images/3/3/10/1.png',
'/images/3/3/10/2.png',
'/images/3/3/10/3.png',
'/images/3/3/10/4.png',
'/images/3/3/10/5.png',
'/images/3/3/10/6.png',
'/images/3/3/10/7.png',
'/images/3/3/10/8.png',
'/images/3/3/10/9.png',
'/images/3/3/10/10.png',
'/images/3/3/10/11.png',
'/images/3/3/10/12.png',
'/images/3/3/10/13.png',
'/images/3/3/10/14.png',
'/images/3/3/10/15.png',
'/images/3/3/10/16.png',
'/images/3/4/1.png',
'/images/3/5/1.png',
'/images/3/6/1.png',
'/images/3/6/2.png',
'/images/3/7/1.png',
'/images/3/8/1.png',
'/images/4/1/1.png',
'/images/4/1/2.png',
'/images/4/1/3.png',
'/images/4/1/4.png',
'/images/4/1/5.png',
'/images/4/2/1.png',
'/images/4/2/2.png',
'/images/4/2/3.png',
'/images/4/2/4.png',
'/images/4/2/5.png',
'/images/4/2/6.png',
'/images/4/3/1.png',
'/images/4/3/2.png',
'/images/4/3/3.png',
'/images/4/3/4.png',
'/images/4/3/5.png',
'/images/4/3/6.png',
'/images/4/5/1.png',
'/images/4/5/2.png',
'/images/4/5/3.png',
'/images/4/5/4.png',
'/images/4/4/1.png',
'/images/4/4/2.png',
'/images/4/4/3.png',
'/images/4/4/4.png',
'/images/4/4/5.png',
'/images/4/4/6.png',
'/images/4/4/7.png',
'/images/4/6/1.png',
'/images/4/6/2.png',
'/images/4/6/3.png',
'/images/4/6/4.png',
'/images/4/6/5.png',
'/images/4/6/6.png',
'/images/4/6/7.png',
'/images/4/6/8.png',
'/images/4/6/9.png',
'/images/4/6/10.png',
'/images/4/6/11.png',
'/images/4/6/12.png',
'/images/4/6/13.png',
'/images/4/6/14.png',
'/images/4/6/15.png',
'/images/4/6/16.png',
'/images/4/7/1.png',
'/images/4/7/2.png',
'/images/4/7/3.png',
'/images/4/7/4.png',
'/images/4/7/5.png',
'/images/4/8/1.png',
'/images/4/8/2.png',
'/images/4/8/3.png',
'/images/4/8/4.png',
'/images/4/8/5.png',
'/images/4/8/6.png',
'/images/4/9/1.png',
'/images/4/9/2.png',
'/images/4/10/1.png',
'/images/4/10/2.png',
'/images/4/10/3.png',
'/images/4/10/4.png',
'/images/4/10/5.png',
'/images/4/11/1.png',
'/images/4/11/2.png',
'/images/4/11/3.png',
'/images/4/11/4.png',
'/images/4/12/1.png',
'/images/4/12/2.png',
'/images/4/12/3.png',
'/images/4/12/4.png',
'/images/4/12/5.png',
'/images/4/12/6.png',
'/images/4/15/1.png',
'/images/4/15/2.png',
'/images/4/15/3.png',
'/images/4/15/4.png',
'/images/4/15/5.png',
'/images/4/15/6.png',
'/images/4/15/7.png',
'/images/4/15/8.png',
'/images/4/16/1.png',
'/images/4/16/2.png',
'/images/4/16/3.png',
'/images/4/16/4.png',
'/images/4/16/5.png',
'/images/4/16/6.png',
'/images/4/16/7.png',
'/images/4/16/8.png',
'/images/4/16/9.png',
'/images/4/16/10.png',
'/images/4/16/11.png',
'/images/4/16/12.png',
'/images/4/16/13.png',
'/images/4/16/14.png',
'/images/4/16/15.png',
'/images/4/17/1.png',
'/images/4/17/2.png',
'/images/4/17/3.png',
'/images/4/17/4.png',
'/images/4/17/5.png',
'/images/4/18/1.png',
'/images/4/18/2.png',
'/images/4/18/3.png',
'/images/4/18/4.png',
'/images/4/18/5.png',
'/images/4/18/6.png',
'/images/4/18/7.png',
'/images/4/18/8.png',
'/images/4/18/9.png',
'/images/4/18/11.png',
'/images/4/19/1.png',
'/images/4/19/2.png',
'/images/4/19/3.png',
'/images/4/19/4.png',
'/images/4/19/5.png',
'/images/4/20/1.png',
'/images/4/20/2.png',
'/images/4/20/3.png',
'/images/4/20/4.png',
'/images/4/20/5.png',
'/images/4/20/6.png',
'/images/4/20/7.png',
'/images/4/20/8.png',
'/images/4/20/9.png',
'/images/4/20/10.png',
'/images/4/20/11.png',
'/images/4/20/12.png',
'/images/4/chaps/1.png',
'/images/4/chaps/2.png',
'/images/4/chaps/3.png',
'/images/4/chaps/4.png',
'/images/4/chaps/5.png',
'/images/4/chaps/6.png',
'/images/4/chaps/7.png',
'/images/4/chaps/8.png',
'/images/4/chaps/9.png',
'/images/5/1/admin_summary.png',
'/images/5/2/administrators.png',
'/images/5/2/edit_admin.png',
'/images/5/3/2.png',
'/images/5/3/business_partner.png',
'/images/5/4/2.png',
'/images/5/4/3.png',
'/images/5/4/4.png',
'/images/5/4/workflow_explained.png',
'/images/5/5/2',
'/images/5/5/3',
'/images/5/5/4',
'/images/5/5/5',
'/images/5/5/client_report_preferences.png',
'/images/7/1/approval_2.png',
'/images/7/1/approval_3.png',
'/images/7/1/approval_4.png',
'/images/7/1/pending_approval.png',
'/images/8/1/info_reports.png',
'/images/8/1/1.png',
'/images/8/1/2.png',
'/images/8/2/1.png',
'/images/8/2/2.png',
'/images/8/3/1.png',
'/images/8/3/2.png',
'/images/8/4/user_activity_audit.png',
'/images/8/4/2.png',
'/images/8/4/3.png',
'/images/9/1/1.png',
'/images/9/1/10.png',
'/images/9/1/11.png',
'/images/9/1/2.png',
'/images/9/1/3.png',
'/images/9/1/4.png',
'/images/9/1/5.png',
'/images/9/1/6.png',
'/images/9/1/7.png',
'/images/9/1/8.png',
'/images/9/1/9.png',
'/images/9/3/1/1.png',
]



// WEBPACK FOOTER //
// ./src/constants/prefetchImages.ts